module.exports = {
      id: "edit-usage",
      viewBox: "0 0 17.505 17.653",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#edit",
      toString: function () {
        return this.url;
      }
    }